import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import DailyInspectionForm from "components/fleet/DailyInspectionForm";
import { UpdateDailyFormInspectionInput } from "generated/graphql";
import useUpdateDailyFormInspection from "hooks/fleet/useUpdateDailyFormInspection";
import useGetDailyFormInspection from "hooks/fleet/useGetDailyFormInspection";

export default function EditDailyInspectionPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [updateInspection, { loading: updating }] = useUpdateDailyFormInspection();

  const { data: inspection } = useGetDailyFormInspection({ id });

  const handleFormSubmit = useCallback(
    async (data: UpdateDailyFormInspectionInput) => {
      if (!id) return;

      const submitData: UpdateDailyFormInspectionInput = {
        ...data,
        id,
      };

      const result = await updateInspection({
        variables: {
          input: submitData,
        },
      });

      if (result.data?.updateDailyFormInspection) {
        navigate("/fleet/daily-inspections");
      }
    },
    [id, updateInspection, navigate]
  );

  const handleCancel = useCallback(() => {
    navigate("/fleet/daily-inspections");
  }, [navigate]);

  return (
    <DashboardPage>
      <MDBox mb={3}>
        <MDTypography variant="h4" fontWeight="medium">
          Edit Daily Inspection
        </MDTypography>
      </MDBox>

      <MDBox>
        <DailyInspectionForm
          type="edit"
          onSubmit={handleFormSubmit}
          onCancel={handleCancel}
          loading={updating}
          inspection={inspection}
        />
      </MDBox>
    </DashboardPage>
  );
}
